export function gtmCustomEventLeadFlow(leadObj:any){
    let dataLayer = (window as any).dataLayer;
    dataLayer?.push(leadObj);
}